const config = {};
config.auto_relogin = true;
config.auto_refresh = false; //if refresh token in moment when system is down - auto logout
//config.default_hostname = '192.168.20.205';
config.connection_timeout = 60000;
config.loader_timeout = 30000;
config.adminMinRoleId = 900; // As admin roleId - 900 and Super Admin roleId = 1000.
export default config;
